var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-details-box" }, [
    _c(
      "div",
      { staticClass: "event-registration-box" },
      [
        _c("payment-summary", {
          attrs: {
            formTitle: _vm.eventConfig["names-label-your-total"],
            priceTitle: "",
            products: _vm.products,
            donationPrice: _vm.donation,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "event-form-wrap event-box-shadow" },
      [
        _c(
          "div",
          { staticClass: "event-rg-form" },
          [
            _c("h6", [_vm._v(_vm._s(_vm.eventConfig["billto-label-details"]))]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "font-weight-light event-info-text" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.eventConfig["billto-label-receipt"]) +
                    "\n        "
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: _vm.eventConfig["billto-label-receipt-details"],
                      placement: "top",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "far fa-info-circle",
                      attrs: { "data-toggle": "tooltip" },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-button-group",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type:
                        _vm.billingType === "individual" ? "primary" : "plain",
                    },
                    on: {
                      click: function ($event) {
                        _vm.billingType = "individual"
                      },
                    },
                  },
                  [_vm._v("\n          Individual\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type:
                        _vm.billingType === "corporate" ? "primary" : "plain",
                    },
                    on: {
                      click: function ($event) {
                        _vm.billingType = "corporate"
                      },
                    },
                  },
                  [_vm._v("\n          Organisation\n        ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "keep-alive",
          [
            _c(_vm.activeForm, {
              tag: "component",
              attrs: {
                eventConfig: _vm.eventConfig,
                billingInfo: _vm.billingInfo,
                donationDetail: _vm.donationDetail,
                tickets: _vm.tickets,
                participants: _vm.participants,
              },
              on: {
                "back-step": _vm.onBackClick,
                "next-step": _vm.onNextClick,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }